import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";
import { ListGroup, ListGroupItem, Button } from "reactstrap";
import GlobalApi from "../services/globalBibleApi";

const SortableItem = SortableElement(ListGroupItem);
const SortableListGroup = SortableContainer(ListGroup);

class BibleSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableBibles: [],
      biblesById: {}
    };
  }

  componentDidMount() {
    GlobalApi.listBibles().then(availableBibles => {
      this.setState({
        availableBibles,
        biblesById: availableBibles.reduce((acc, bible) => {
          acc[bible.id] = bible;
          return acc;
        }, {})
      });
    });
  }

  onBibleSelect = event => {
    if (this.props.value.find(bible => bible.id === event.value)) {
      return;
    }

    const eventBible = this.state.biblesById[event.value];

    // hack to update data by populating all bibles with API data on change
    const updatedPropsValue = this.props.value.map(
      bible => this.state.biblesById[bible.id] || bible
    );
    const selectedBibles = [...updatedPropsValue, eventBible];
    this.props.onChange({
      target: {
        name: this.props.name,
        value: selectedBibles
      }
    });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    const selectedBibles = arrayMove(this.props.value, oldIndex, newIndex);
    this.props.onChange({
      target: {
        name: this.props.name,
        value: selectedBibles
      }
    });
  };

  removeSelectedBible = bibleId => {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: this.props.value.filter(bible => bible.id !== bibleId)
      }
    });
  };

  render() {
    const options = this.state.availableBibles.map(bible => ({
      label: `${bible.language.name} - ${bible.abbreviation} - ${bible.name}`,
      value: bible.id
    }));
    return (
      <div>
        <SortableListGroup onSortEnd={sortState => this.onSortEnd(sortState)}>
          <Select
            name="bible-select"
            options={options}
            onChange={this.onBibleSelect}
            placeholder="Add a Bible..."
          />
          {this.state.availableBibles.length > 0 &&
            this.props.value.map(selectedBible => {
              const bible = this.state.biblesById[selectedBible.id] || {
                ...selectedBible,
                unlicensed: true
              };
              const index = this.props.value.indexOf(selectedBible);
              if (!bible) {
                return null;
              }
              return (
                <SortableItem
                  key={bible.id}
                  index={index}
                  className="d-flex justify-content-between"
                >
                  <div>
                    {bible.language.name} -{bible.abbreviation} -{bible.name}{" "}
                    {bible.unlicensed ? " - Unlicensed" : ""}
                  </div>
                  <div>
                    <Button
                      type="button"
                      className="close"
                      onClick={() => this.removeSelectedBible(bible.id)}
                    >
                      &times;
                    </Button>
                  </div>
                </SortableItem>
              );
            })}
        </SortableListGroup>
      </div>
    );
  }
}

BibleSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired
};

export default BibleSelect;
